"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scrollbar = void 0;
var react_1 = require("react");
var smooth_scrollbar_1 = __importDefault(require("smooth-scrollbar"));
var SmoothScrollbarReact = (0, react_1.forwardRef)(function SmoothScrollbarReact(_a, ref) {
    var _this = this;
    var children = _a.children, className = _a.className, style = _a.style, restProps = __rest(_a, ["children", "className", "style"]);
    var mountedRef = (0, react_1.useRef)(false);
    var scrollbar = (0, react_1.useRef)(null);
    var handleScroll = (0, react_1.useCallback)(function (status) {
        if (typeof restProps.onScroll === 'function') {
            restProps.onScroll(status, scrollbar.current);
        }
    }, [restProps.onScroll]);
    var containerRef = (0, react_1.useCallback)(function (node) {
        if (node instanceof HTMLElement) {
            (function () { return __awaiter(_this, void 0, void 0, function () {
                var OverscrollPlugin;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!((_a = restProps.plugins) === null || _a === void 0 ? void 0 : _a.overscroll)) return [3 /*break*/, 2];
                            return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('smooth-scrollbar/plugins/overscroll')); })];
                        case 1:
                            OverscrollPlugin = (_b.sent()).default;
                            smooth_scrollbar_1.default.use(OverscrollPlugin);
                            _b.label = 2;
                        case 2:
                            scrollbar.current = smooth_scrollbar_1.default.init(node, restProps);
                            scrollbar.current.addListener(handleScroll);
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (ref) {
            ref.current = scrollbar.current;
        }
        return function () {
            if (scrollbar.current) {
                scrollbar.current.removeListener(handleScroll);
                scrollbar.current.destroy();
            }
        };
    }, []);
    (0, react_1.useEffect)(function () {
        if (mountedRef.current === true) {
            if (scrollbar.current) {
                Object.keys(restProps).forEach(function (key) {
                    if (!(key in scrollbar.current.options)) {
                        return;
                    }
                    if (key === 'plugins') {
                        Object.keys(restProps.plugins).forEach(function (pluginName) {
                            scrollbar.current.updatePluginOptions(pluginName, restProps.plugins[pluginName]);
                        });
                    }
                    else {
                        // @ts-expect-error
                        scrollbar.current.options[key] = restProps[key];
                    }
                });
                scrollbar.current.update();
            }
        }
        else {
            mountedRef.current = true;
        }
    }, [restProps]);
    if ((0, react_1.isValidElement)(children)) {
        return (0, react_1.cloneElement)(children, {
            ref: containerRef,
            className: (children.props.className ? "".concat(children.props.className, " ") : '') +
                className,
            style: __assign(__assign({}, style), children.props.style),
        });
    }
    return (0, react_1.createElement)('div', {
        ref: containerRef,
        className: className,
        style: __assign(__assign({}, style), { WebkitBoxFlex: 1, msFlex: 1, MozFlex: 1, flex: 1 }),
    }, (0, react_1.createElement)('div', {
        className: className,
    }, children));
});
exports.Scrollbar = SmoothScrollbarReact;
